<template>
    <div class="ds-dropdown-separator">
        <div class="bar"></div>
    </div>
</template>
<style scoped lang="scss">
.ds-dropdown-separator {
    width: 100%;
    padding: 2px 0;
    .bar {
        height: 1px;
        background-color: $stroke-sub-300;
    }
}
</style>
